import { ScreenName } from '@helpcenter/constants';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { getRelayEnvironment } from '@atlassian/help-center-common-util/relay';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { loadQuery, type PreloadedQuery } from 'react-relay';
import { createResource } from 'react-resource-router';
import { NUMBER_OF_HELP_CENTERS_INITIAL_FETCH, SORT_ORDER } from '../../constants';
import type { migrationDataCandidatesQuery } from '../help-center-migration-wizard/__generated__/migrationDataCandidatesQuery.graphql';
import MigrationDataCandidatesQuery from '../help-center-migration-wizard/__generated__/migrationDataCandidatesQuery.graphql';
import type { helpCentersManagementPageQuery } from './__generated__/helpCentersManagementPageQuery.graphql';
import HelpCentersManagementPageQuery from './__generated__/helpCentersManagementPageQuery.graphql';

const HELP_HUB_MIGRATION_GATE = 'enable-help-hub-migration';

export const HelpCentersManagementResource = createRelayResource<helpCentersManagementPageQuery>({
	type: 'HELP_CENTERS_MANAGEMENT',
	getQuery: ({ route }, { cloudId, workspaceAri }) => {
		const isHelpHubRoute = route.name === ScreenName.HELP_HUBS_MANAGEMENT;
		const filterType = isHelpHubRoute ? 'HELP_HUB' : 'BASIC';

		return {
			parameters: HelpCentersManagementPageQuery,
			variables: {
				cloudId,
				workspaceAri,
				SORT_ORDER,
				NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
				filterType: FeatureGates.checkGate('enable-jsm-in-hubs') ? filterType : null,
			},
			options: {
				fetchPolicy: 'store-or-network',
			},
		};
	},
});

export const MigrationCandidatesResource =
	createResource<PreloadedQuery<migrationDataCandidatesQuery> | null>({
		type: 'RELAY_RESOURCE_TYPE_MIGRATION_CANDIDATES',
		getKey: ({ query, route }, { cloudId, workspaceAri }) =>
			`MIGRATION_CANDIDATES:${route.name}:${query.migrationStep ?? ''}:${cloudId}:${workspaceAri}`,
		getData: ({ query, route }, { cloudId, workspaceAri }) => {
			if (
				route.name !== ScreenName.HELP_CENTERS_MANAGEMENT ||
				query.migrationStep !== 'select' ||
				!FeatureGates.checkGate(HELP_HUB_MIGRATION_GATE)
			) {
				return null;
			}

			return loadQuery<migrationDataCandidatesQuery>(
				getRelayEnvironment(),
				MigrationDataCandidatesQuery,
				{ cloudId, workspaceAri },
				{ fetchPolicy: 'store-or-network' },
			);
		},
		maxAge: 0,
	});
